import * as React from "react"
export const Svg_038 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={60}
    height={59}
    fill="none"
  >
    <path fill="url(#a)" d="M24.61 29.5h3.515v3.457H24.61V29.5Z" />
    <path fill="url(#b)" d="M17.578 29.5h3.516v3.457h-3.516V29.5Z" />
    <path fill="url(#c)" d="M24.61 36.414h3.515v10.371H24.61v-10.37Z" />
    <path
      fill="url(#d)"
      d="M0 55.428h38.672v-34.57H0v34.57Zm31.64-29.385v24.2H7.032v-24.2h24.61Z"
    />
    <path fill="url(#e)" d="M10.547 36.414h3.515v3.457h-3.515v-3.457Z" />
    <path fill="url(#f)" d="M10.547 29.5h3.515v3.457h-3.515V29.5Z" />
    <path fill="url(#g)" d="M17.578 36.414h3.516v3.457h-3.516v-3.457Z" />
    <path fill="url(#h)" d="M10.547 43.328h3.515v3.457h-3.515v-3.457Z" />
    <path
      fill="url(#i)"
      d="M38.672 3.572H0V17.4h38.672V3.572Zm-14.063 8.8h-3.515V8.915h3.515v3.457Zm3.516 0V8.915h3.516v3.457h-3.516Z"
    />
    <path fill="url(#j)" d="M17.578 43.328h3.516v3.457h-3.516v-3.457Z" />
    <path fill="url(#k)" d="M42.344 31.229H60v5.761H42.344V31.23Z" />
    <path fill="url(#l)" d="M42.344 40.447H60v5.762H42.344v-5.762Z" />
    <path fill="url(#m)" d="M42.344 49.666H60v5.762H42.344v-5.762Z" />
    <defs>
      <linearGradient
        id="a"
        x1={25.422}
        x2={27.052}
        y1={30.019}
        y2={32.701}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={18.391}
        x2={20.021}
        y1={30.019}
        y2={32.701}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={25.422}
        x2={30.068}
        y1={37.97}
        y2={40.519}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={8.943}
        x2={24.485}
        y1={26.043}
        y2={54.181}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={11.36}
        x2={12.989}
        y1={36.933}
        y2={39.615}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={11.36}
        x2={12.989}
        y1={30.019}
        y2={32.701}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={18.391}
        x2={20.021}
        y1={36.933}
        y2={39.615}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="h"
        x1={11.36}
        x2={12.989}
        y1={43.847}
        y2={46.529}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="i"
        x1={8.943}
        x2={12.037}
        y1={5.646}
        y2={19.652}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="j"
        x1={18.391}
        x2={20.021}
        y1={43.847}
        y2={46.529}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="k"
        x1={46.427}
        x2={47.613}
        y1={32.093}
        y2={37.974}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="l"
        x1={46.427}
        x2={47.613}
        y1={41.312}
        y2={47.193}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="m"
        x1={46.427}
        x2={47.613}
        y1={50.53}
        y2={56.412}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)